import { QueryClient } from '@tanstack/react-query'

/**
 * The app's one React Query client.
 *
 * A module export rather than a `main.tsx` local so a non-component — the
 * View-as switch (SA-906) — can `clear()` it when the signed-in identity
 * changes. Nothing else should hold cached data across that boundary.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
})
